// extracted by mini-css-extract-plugin
export default {"createForumThread":"CreateForumThread_createForumThread__i+QXG"};